<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path" :style="item.path == '/dashboard'?'display:none;':''">
        <span
          v-if="item.path != '/dashboard' || index==levelList.length-1"
          class="no-redirect"
        >{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
        <!-- <span
          v-if="item.redirect==='noRedirect'||index==levelList.length-1"
          class="no-redirect"
        >{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>-->
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from "path-to-regexp";

export default {
  data() {
    return {
      levelList: null
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
        item => item.meta && item.meta.title
      );
      const first = matched[0];

      // if (!this.isDashboard(first)) {
      //   matched = [{ path: "/dashboard", meta: { title: "工作台" } }].concat(matched);
      // }

      this.levelList = matched.filter(
        item => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
      // console.log(this.levelList);
    },
    isDashboard(route) {
      const path = route && route.path;
      if (!path) {
        return false;
      }
      return path.trim().toLocaleLowerCase() === "/dashboard".toLocaleLowerCase();
    },
    // pathCompile(path) {
    //   // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
    //   const { params } = this.$route;
    //   console.log(params);
    //   var toPath = pathToRegexp.compile(path);
    //   return toPath(params);
    // },
    handleLink(item) {
      // console.log(item);
      // const { redirect, path } = item;
      // console.log(redirect);
      // console.log(path);

      this.$router.push(item.path);

      // if (redirect) {
      //   this.$router.push(redirect);
      //   return;
      // }
      // this.$router.push(this.pathCompile(path));
    }
  }
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
